import React from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import { NotificationsContext } from 'src/contexts'
import { LocalizedText } from '../../intl'
import { useHandler } from '../../../hooks'
import FileDropInput from './FileDropInput'

const checkExtensions = (files = [], extensions = []) =>
  !extensions ||
  !extensions.length ||
  files.every(({ name }) => extensions.find(extension => name.toLowerCase().endsWith(`.${extension.toLowerCase()}`)))

/**
 * First hook component ever created in labguard-react \o/
 */
const FileDropInputContainer = ({ value, onChange, extensions, ...props }) => {
  const { notifyError } = NotificationsContext.use()
  const reject = useHandler(() => notifyError({ title: <LocalizedText id="WEB_INVALID_FILE" /> }))
  const { getRootProps, getInputProps, open } = useDropzone({
    onDropRejected: reject,
    onDropAccepted: files => (checkExtensions(files, extensions) ? onChange(files) : reject()),
    ...props,
  })
  const { ref, ...rootProps } = getRootProps({
    // Disable click and keydown behavior
    onClick: event => event.stopPropagation(),
  })

  const onOpen = useHandler(e => {
    e.preventDefault()
    open()
  })

  return <FileDropInput {...rootProps} inputProps={getInputProps()} value={value} onOpen={onOpen} />
}

export default FileDropInputContainer

FileDropInputContainer.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  /**
   * Array of allowed extensions (without the first dot)
   * @example ['zip', 'tar.gz']
   */
  extensions: PropTypes.array,
}

FileDropInputContainer.defaultProps = {
  value: [],
  extensions: [],
}
